import React from "react";

export default function CompletePlant() {
  return (
    <svg width="320" height="420" viewBox="0 0 320 420" className="drop-shadow-2xl">
      <defs>
        {/* Gradients stylés */}
        <linearGradient id="potCyber" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#3A506B" />
          <stop offset="50%" stopColor="#5BC0BE" />
          <stop offset="100%" stopColor="#0B132B" />
        </linearGradient>
        
        <linearGradient id="stemGlow" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#6FCF97" />
          <stop offset="100%" stopColor="#1B5E20" />
        </linearGradient>
        
        <linearGradient id="leaf1Grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#6FCF97" />
          <stop offset="100%" stopColor="#27AE60" />
        </linearGradient>
        
        <linearGradient id="leaf2Grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#81C784" />
          <stop offset="100%" stopColor="#4CAF50" />
        </linearGradient>
        
        <linearGradient id="leaf3Grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#A5D6A7" />
          <stop offset="100%" stopColor="#66BB6A" />
        </linearGradient>
        
        {/* Filtre glow cyber */}
        <filter id="glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>

      {/* POT CYBER STYLE */}
      <g id="pot">
        {/* Corps du pot */}
        <path
          d="M 100 320 L 95 395 Q 95 402, 102 402 L 218 402 Q 225 402, 225 395 L 220 320 Z"
          fill="url(#potCyber)"
          stroke="#5BC0BE"
          strokeWidth="2"
        />
        {/* Bord supérieur lumineux */}
        <ellipse cx="160" cy="320" rx="62" ry="14" fill="#0B132B" stroke="#5BC0BE" strokeWidth="2.5" />
        <ellipse cx="160" cy="320" rx="58" ry="10" fill="#3A506B" opacity="0.6" />
        
        {/* Motifs géométriques cyber */}
        <line x1="110" y1="340" x2="210" y2="340" stroke="#5BC0BE" strokeWidth="1" opacity="0.3" />
        <line x1="107" y1="360" x2="213" y2="360" stroke="#5BC0BE" strokeWidth="1" opacity="0.3" />
        <circle cx="130" cy="370" r="3" fill="#5BC0BE" opacity="0.5" />
        <circle cx="190" cy="370" r="3" fill="#5BC0BE" opacity="0.5" />
      </g>

      {/* TERRE / SUBSTRAT */}
      <ellipse cx="160" cy="320" rx="58" ry="12" fill="#1B3A1F" opacity="0.8" />

      {/* TIGES PRINCIPALES avec glow */}
      <g id="stems" filter="url(#glow)">
        {/* Tige centrale principale */}
        <path
          d="M 160 320 Q 158 260, 160 200 Q 162 140, 160 80 Q 159 40, 160 20"
          stroke="url(#stemGlow)"
          strokeWidth="10"
          fill="none"
          strokeLinecap="round"
        />
        
        {/* Tige secondaire gauche haute */}
        <path
          d="M 160 140 Q 140 125, 115 105"
          stroke="#3E7D32"
          strokeWidth="6"
          fill="none"
          strokeLinecap="round"
        />
        
        {/* Tige secondaire droite haute */}
        <path
          d="M 160 120 Q 180 105, 205 85"
          stroke="#3E7D32"
          strokeWidth="6"
          fill="none"
          strokeLinecap="round"
        />
        
        {/* Tige secondaire gauche basse */}
        <path
          d="M 160 220 Q 135 210, 105 195"
          stroke="#3E7D32"
          strokeWidth="6"
          fill="none"
          strokeLinecap="round"
        />
        
        {/* Tige secondaire droite basse */}
        <path
          d="M 160 240 Q 185 230, 210 215"
          stroke="#3E7D32"
          strokeWidth="6"
          fill="none"
          strokeLinecap="round"
        />
      </g>

      {/* FEUILLE 1 - Sommet (FRAGMENT A) */}
      <g id="leaf-fragment-a" filter="url(#glow)">
        <path
          d="M 160 20 Q 140 25, 125 40 Q 115 55, 118 75 Q 125 92, 145 100 Q 158 104, 168 98 Q 175 85, 172 68 Q 168 45, 160 20 Z"
          fill="url(#leaf1Grad)"
          stroke="#1B5E20"
          strokeWidth="2.5"
        />
        {/* Nervure centrale */}
        <path d="M 160 20 Q 145 55, 142 98" stroke="#0D3D0D" strokeWidth="2" fill="none" opacity="0.7" />
        {/* Nervures secondaires */}
        <path d="M 145 40 Q 130 45, 122 52" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
        <path d="M 148 60 Q 133 65, 125 72" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
        <path d="M 152 80 Q 138 85, 130 92" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      </g>

      {/* FEUILLE 2 - Droite haute (FRAGMENT B) */}
      <g id="leaf-fragment-b" filter="url(#glow)">
        <ellipse
          cx="220" cy="95" rx="38" ry="48"
          fill="url(#leaf2Grad)"
          stroke="#1B5E20"
          strokeWidth="2.5"
          transform="rotate(-20 220 95)"
        />
        {/* Nervure centrale */}
        <path d="M 220 50 L 220 140" stroke="#0D3D0D" strokeWidth="2.5" fill="none" opacity="0.7" transform="rotate(-20 220 95)" />
        {/* Nervures latérales gauches */}
        <path d="M 220 65 Q 200 70, 190 75" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
        <path d="M 220 85 Q 200 90, 190 95" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
        <path d="M 220 105 Q 200 110, 190 115" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
        <path d="M 220 125 Q 200 130, 190 135" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
        {/* Nervures latérales droites */}
        <path d="M 220 65 Q 240 70, 250 75" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
        <path d="M 220 85 Q 240 90, 250 95" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
        <path d="M 220 105 Q 240 110, 250 115" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
        <path d="M 220 125 Q 240 130, 250 135" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
      </g>

      {/* FEUILLE 3 - Gauche haute dentelée (FRAGMENT C) */}
      <g id="leaf-fragment-c" filter="url(#glow)">
        <path
          d="M 115 105 L 88 115 L 72 128 L 65 148 L 70 168 L 85 185 L 108 192 L 128 185 L 135 165 L 128 140 L 115 105 Z"
          fill="url(#leaf3Grad)"
          stroke="#1B5E20"
          strokeWidth="2.5"
        />
        {/* Nervure centrale */}
        <path d="M 115 105 L 100 160 L 95 185" stroke="#0D3D0D" strokeWidth="2" fill="none" opacity="0.7" />
        {/* Nervures dentelées */}
        <path d="M 108 125 L 88 130" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
        <path d="M 103 145 L 75 152" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
        <path d="M 105 165 L 82 172" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
        <path d="M 115 135 L 125 138" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
        <path d="M 112 155 L 128 160" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      </g>

      {/* FEUILLE 4 - Gauche basse (FRAGMENT D) */}
      <g id="leaf-fragment-d" filter="url(#glow)">
        <path
          d="M 105 195 Q 85 200, 70 212 Q 58 228, 60 248 Q 68 268, 88 278 Q 108 283, 125 275 Q 138 263, 138 243 Q 132 220, 105 195 Z"
          fill="url(#leaf1Grad)"
          stroke="#1B5E20"
          strokeWidth="2.5"
        />
        {/* Nervure centrale */}
        <path d="M 105 195 Q 90 230, 92 275" stroke="#0D3D0D" strokeWidth="2" fill="none" opacity="0.7" />
        {/* Nervures secondaires */}
        <path d="M 95 215 Q 78 222, 68 230" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
        <path d="M 92 235 Q 73 242, 63 250" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
        <path d="M 93 255 Q 77 262, 70 270" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
        <path d="M 100 218 Q 118 222, 128 228" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
        <path d="M 102 238 Q 120 242, 132 248" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      </g>

      {/* FEUILLE 5 - Droite basse allongée (FRAGMENT E) */}
      <g id="leaf-fragment-e" filter="url(#glow)">
        <path
          d="M 210 215 Q 230 220, 245 232 Q 258 248, 258 268 Q 253 288, 235 298 Q 215 305, 198 298 Q 185 288, 185 268 Q 190 242, 210 215 Z"
          fill="url(#leaf2Grad)"
          stroke="#1B5E20"
          strokeWidth="2.5"
        />
        {/* Nervure centrale */}
        <path d="M 210 215 Q 222 250, 222 295" stroke="#0D3D0D" strokeWidth="2" fill="none" opacity="0.7" />
        {/* Nervures secondaires */}
        <path d="M 218 235 Q 235 242, 245 250" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
        <path d="M 220 255 Q 238 262, 250 270" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
        <path d="M 220 275 Q 235 282, 245 290" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
        <path d="M 218 240 Q 200 245, 192 252" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
        <path d="M 220 260 Q 203 265, 195 272" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      </g>
    </svg>
  );
}